import theme from "css/theme/light";

const MarkerIconArrow = (marker: google.maps.Marker, rotation?: number) => {

    const icon = marker.setIcon({
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        fillColor: (theme.palette.secondary as any)["600"],
        fillOpacity: 1,
        scale: 5,
        strokeColor: (theme.palette.secondary as any)["600"],
        strokeWeight: 1,
        rotation: rotation
    });

    return icon;
};
export default MarkerIconArrow;
